import gql from 'graphql-tag';

const NAME = 'compositions_CaseStatus_sendToFixpixMutation';

export default gql`
  mutation ${NAME} ($id: ID!) {
    sendToFixpix(input: { id: $id }) {
      case { id status fixpixPushResult }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/compositions/CaseStatus/withSendToFixpix/sendToFixpixMutation.js